import { Plat_isCordova } from '../Plat/Plat.device'
import { cordovaSelectSaveAndUpload } from '../../../app-core/lib/upload/cordovaSelectSaveAndUpload'
import type { FileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'
import type { UploadGroupId } from '../../../app-core/lib/upload/Upload'
import { writeCordovaFileContentToDisk } from './writeCordovaFileContentToDisk'
import { generateFileId } from '../../../shared/domain/files/types.no-deps'
import { appUploadQueue } from './AppUploadQueue'
import { htmlSelectSaveAndUpload } from '../../../app-core/lib/upload/htmlSelectSaveAndUpload'
import { writeHtmlFileToDisk } from './writeHtmlFileToDisk'
import { getMimeTypeFromExtension } from '../../../shared/lib/mimeTypes.no-deps'
import type { FileUploadData } from '../../../app-core/lib/upload/FileUploadData'
import { Logg_createLogger } from '../Logg/Logg.Logger'

export const selectFile = async (
    groupId: UploadGroupId,
    fileExtensions: FileExtension[],
    customer: number,
    isIOS?: boolean,
    type?: 'image' | 'video'
): Promise<FileUploadData[]> => {
    const logger = Logg_createLogger('Uplo.selectFile')

    if (Plat_isCordova()) {
        return [
            await cordovaSelectSaveAndUpload({
                acceptedExtensions: fileExtensions,
                acceptedMimeTypes: fileExtensions.map(getMimeTypeFromExtension),
                cordovaGetFile: chooser.getFile,
                fileId: generateFileId(),
                groupId,
                writeFileContentToDisk: writeCordovaFileContentToDisk,
                uploadQueue: appUploadQueue,
                customer,
                logger,
            }),
        ]
    }
    return htmlSelectSaveAndUpload({
        acceptedExtensions: fileExtensions,
        generateFileId,
        groupId,
        uploadQueue: appUploadQueue,
        writeFileContentToDisk: writeHtmlFileToDisk,
        customer,
        logger,
        isIOS,
        type,
    })
}
